import { Component, inject, input } from '@angular/core';
import { ApplicationService } from "../../../services/application.service";
import { AsyncPipe } from "@angular/common";
import { GalleriaModule } from "primeng/galleria";
import {
  ApartmentDetailPageContentComponent
} from "../../../components/apartment-detail-page-content/apartment-detail-page-content.component";
import { UserService } from "../../../services/user.service";
import { EstimatedEligibilityPipe } from "../../../pipes/estimated-eligibility.pipe";
import { SubmitButtonComponent } from "../../../components/submit-button/submit-button.component";
import { ApartmentRelevantAdvertisementsPipe } from "../../../pipes/apartment-relevant-advertisements.pipe";
import { ApartmentDetailInfoItemComponent } from "./apartment-detail-info-item/apartment-detail-info-item.component";
import {RegularEligibleUnitsComponent} from "../../../components/apartment-detail-page-content/eligible-units-component/regular-eligible-units.component";
import {SeniorEligibleUnitsComponent} from "../../../components/apartment-detail-page-content/eligible-units-component/senior-eligible-units.component";
import { MaxHouseholdSizePipe } from "../../../pipes/max-household-size.pipe";
import { MinHouseholdSizePipe } from "../../../pipes/min-household-size.pipe";
import { Button } from "primeng/button";
import { ModalService } from "../../../services/modal.service";
import { MessageService } from "primeng/api";
import { LotteryTimelineComponent } from "../../../components/lottery-timeline/lottery-timeline.component";
import { RouterLink } from "@angular/router";
import { TranslocoPipe, TranslocoService } from "@jsverse/transloco";
import {ConfirmDialog} from "primeng/confirmdialog";

@Component({
  standalone: true,
  imports: [
    AsyncPipe,
    GalleriaModule,
    ApartmentDetailPageContentComponent,
    EstimatedEligibilityPipe,
    SubmitButtonComponent,
    ApartmentRelevantAdvertisementsPipe,
    ApartmentDetailInfoItemComponent,
    RegularEligibleUnitsComponent,
    SeniorEligibleUnitsComponent,
    MaxHouseholdSizePipe,
    MinHouseholdSizePipe,
    Button,
    LotteryTimelineComponent,
    RouterLink,
    TranslocoPipe,
    ConfirmDialog
  ],
  templateUrl: './apartment-detail-page.component.html',
})
export class ApartmentDetailPageComponent {
  constructor(
    private readonly applicationService: ApplicationService,
    private readonly userService: UserService
  ) {}

  private readonly modalService = inject(ModalService);
  private readonly messageService = inject(MessageService);
  private readonly t = inject(TranslocoService);

  public readonly yesterday = new Date(Date.now() - 36 * 60 * 60 * 1000).toISOString();

  public readonly lotteryId = input.required<string>();
  public readonly apartmentWithApplicationInfo = this.applicationService.getApartmentById(this.lotteryId)

  protected readonly user$ = this.userService.getCurrentUserAfterSignupFlow$();
  protected readonly encodeURIComponent = encodeURIComponent;

  public readonly apply = () =>
    this.applicationService.applyForApartment(this.apartmentWithApplicationInfo()!.id);

  protected onWithdrawClick() {
    const title = this.t.translate('common.dialog.withdrawConfirm.title');
    const body  = this.t.translate('common.dialog.withdrawConfirm.body');

    this.modalService.openYesNoModal(body, title, "lottery-confirm").subscribe((result) => {
      if (result === 'yes') {
        this.applicationService
          .withdrawApplication(this.apartmentWithApplicationInfo()!.application!.id!)
          .subscribe(() => {
            this.messageService.add({
              severity: 'success',
              summary: this.t.translate('common.toast.applicationWithdrawn.summary'),
              detail:  this.t.translate('common.toast.applicationWithdrawn.detail'),
            });
          });
      }
    });
  }
}
